import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { SET_FILTER } from '../../store/types';
import { getNewFilterdProducts } from '../../store/actions/product-actions';

const ShopColor = ({ colors }) => {
  const dispatch = useDispatch();
  const currentFilters = useSelector(state => state.products.filter);

  const handleColorClick = (color) => {
    // Handle array of colors
    const updatedColors = currentFilters.color.includes(color)
      ? currentFilters.color.filter(c => c !== color) // Remove if exists
      : [...currentFilters.color, color]; // Add if doesn't exist

    // Update the filter in Redux
    dispatch({
      type: SET_FILTER,
      payload: {
        filterType: 'color',
        value: updatedColors
      }
    });

    // Fetch filtered products with updated colors
    dispatch(getNewFilterdProducts({
      ...currentFilters,
      page: 1,
      limit: 15,
      color: updatedColors
    }));
  };

  const handleClearColors = () => {
    dispatch({
      type: SET_FILTER,
      payload: {
        filterType: 'color',
        value: []
      }
    });

    dispatch(getNewFilterdProducts({
      ...currentFilters,
      page: 1,
      limit: 15,
      color: []
    }));
  };

  return (
    <div style={{
      padding: "24px",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      backgroundColor: "white",
      marginTop: "50px"
    }}>
      {/* Color Filter Section */}
      <h4 style={{
        fontSize: "16px",
        fontWeight: "600",
        color: "#2d3748",
        marginBottom: "16px",
        paddingBottom: "8px",
        borderBottom: "1px solid #edf2f7"
      }}>Color</h4>

      <div style={{ marginTop: "20px" }}>
        {colors ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {/* All Colors Option */}
            <label style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: "8px 0"
            }}>
              <input
                type="checkbox"
                checked={currentFilters.color.length === 0}
                onChange={handleClearColors}
                style={{
                  width: "16px",
                  height: "16px",
                  accentColor: "#4299e1",
                  marginRight: "12px",
                  cursor: "pointer"
                }}
              />
              <span style={{
                color: currentFilters.color.length === 0 ? "#4299e1" : "#4a5568",
                fontSize: "14px"
              }}>
                All Colors
              </span>
            </label>

            {/* Individual Color Options */}
            {colors.map((color, key) => (
              <label
                key={key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px 0"
                }}
              >
                <input
                  type="checkbox"
                  checked={currentFilters.color.includes(color)}
                  onChange={() => handleColorClick(color)}
                  style={{
                    width: "16px",
                    height: "16px",
                    accentColor: "#4299e1",
                    marginRight: "12px",
                    cursor: "pointer"
                  }}
                />
                <span style={{
                  color: currentFilters.color.includes(color) ? "#4299e1" : "#4a5568",
                  fontSize: "14px",
                  textTransform: "capitalize"
                }}>
                  {color}
                </span>
              </label>
            ))}
          </div>
        ) : (
          <div style={{ color: "#718096", fontSize: "14px" }}>No color options found</div>
        )}
      </div>
    </div>
  );
};

ShopColor.propTypes = {
  colors: PropTypes.array.isRequired,
};

export default ShopColor;